import React, {useState} from 'react';
import './Home.scss'
import {Config} from "src/config";

export const HomeComponent = () => {
    const [showFirstButtonCard, setShowFirstButtonCard] = useState(false);

    const chronografDescription = "Accedi alla dashboard personalizzata di Chronograf per monitorare e gestire i tuoi dati";
    const onClick = () => {
        window.location.href = Config.chronografUrl;
    }
    return (
        <>
            {showFirstButtonCard && (
                <div className="button-card-body">
                    <button className="card-button">
                        Gestione Utenti
                    </button>
                    <button type={"button"} onClick={onClick} className="card-button">
                        Chronograf
                    </button>
                </div>
            )}
            <div className="button-card-body">
                <div className="chronograf-logo-card"></div>
                <button className="card-button" onClick={onClick}>
                    Chronograf
                </button>
                <p>
                    {chronografDescription}
                </p>
            </div>
        </>
    );
};
